import React from 'react'
import { useSelector } from 'react-redux'
import { Redirect, Route } from 'react-router-dom'
import { selectIsSignedIn } from 'slices/authSlice'

function PrivateRoute({ component, ...rest }) {
  const isSignedIn = useSelector(selectIsSignedIn)
  return (
    <Route
      {...rest}
      render={(props) => {
        // check if user is not authenticated
        if (!isSignedIn) {
          return (
            <Redirect
              to={{
                pathname: '/login',
                state: {
                  from: props.location
                }
              }}
            />
          )
        }

        return React.createElement(component, props)
      }}
    />
  )
}

export default PrivateRoute
